/* eslint-disable no-shadow */
/* eslint-disable @typescript-eslint/naming-convention */
import { createAction, props } from '@ngrx/store';

export enum ActionTypes {
  GET_USER_PROFILE = '[Account] Get User Profile',
  GET_USER_PROFILE_SUCCESS = '[Account] Get User Profile Success',
  GET_USER_PROFILE_FAILED = '[Account] Get User Profile Failed',

  GET_APPLICANT_DETAILS = '[Account] Get Applicant Details',
  GET_APPLICANT_DETAILS_SUCCESS = '[Account] Get Applicant Details Success',
  GET_APPLICANT_DETAILS_FAILED = '[Account] Get Applicant Details Failed',

  VERIFY_APPLICATION = '[Account] Verify Applciation',
  VERIFY_APPLICATION_SUCCESS = '[Account] Verify Applciation Success',
  VERIFY_APPLICATION_FAILED = '[Account] Verify Applciation Failed',

  TRANSMIT_APPLICATION = '[Account] Transmit Applciation',
  TRANSMIT_APPLICATION_SUCCESS = '[Account] Transmit Applciation Success',
  TRANSMIT_APPLICATION_FAILED = '[Account] Transmit Applciation Failed',

  CHANGE_PASSWORD = '[Account] Change Password',
  CHANGE_PASSWORD_SUCCESS = '[Account] Change Password Success',
  CHANGE_PASSWORD_FAILED = '[Account] Change Password Failed',

  CHANGE_PASSWORD_MODAL = '[Account] Change Password Modal',
  CHANGE_PASSWORD_MODAL_SUCCESS = '[Account] Change Password Modal Success',
  CHANGE_PASSWORD_MODAL_FAILED = '[Account] Change Password Modal Failed',

  GET_DASHBOARD_COUNTS = '[Account] Get Dashboard Counts',
  GET_DASHBOARD_COUNTS_SUCCESS = '[Account] Get Dashboard Counts Success',
  GET_DASHBOARD_COUNTS_FAILED = '[Account] Get Dashboard Counts Failed',

  FROM_PAGE = '[Encoding] From page',

  // --- Roles ---
  GET_ROLES_PERMISSIONS = '[Account] Get Roles & Permissions',
  GET_ROLES_PERMISSIONS_SUCCESS = '[Account] Get Roles & Permissions Success',
  GET_ROLES_PERMISSIONS_FAILED = '[Account] Get Roles & Permissions Failed',

  // --- Permissions ---
  GET_PERMISSIONS = '[Account] Get Permissions',
  GET_PERMISSIONS_SUCCESS = '[Account] Get Permissions Success',
  GET_PERMISSIONS_FAILED = '[Account] Get Permissions Failed',
}

export const getUserProfile = createAction(
  ActionTypes.GET_USER_PROFILE
);

export const getUserProfileSuccess = createAction(
  ActionTypes.GET_USER_PROFILE_SUCCESS,
  props<{ data: any }>()
);

export const getUserProfileFailed = createAction(
	ActionTypes.GET_USER_PROFILE_FAILED,
  props<{ data: any }>()
);

export const getApplicantDetails = createAction(
  ActionTypes.GET_APPLICANT_DETAILS,
  props<{ uuid: any, redirect: Boolean, tranType: any }>()
);

export const getApplicantDetailsSuccess = createAction(
  ActionTypes.GET_APPLICANT_DETAILS_SUCCESS,
  props<{ data: any, redirect: Boolean, tranType: any }>()
);

export const getApplicantDetailsFailed = createAction(
	ActionTypes.GET_APPLICANT_DETAILS_FAILED,
  props<{ data: any }>()
);

export const verifyApplication = createAction(
  ActionTypes.VERIFY_APPLICATION,
  props<{ uuid: string, data: any }>()
);

export const verifyApplicationSuccess = createAction(
  ActionTypes.VERIFY_APPLICATION_SUCCESS,
  props<{ uuid: any, data: any }>()
);

export const verifyApplicationFailed = createAction(
  ActionTypes.VERIFY_APPLICATION_FAILED,
  props<{ data: any }>()
);

export const transmitApplication = createAction(
  ActionTypes.TRANSMIT_APPLICATION,
  props<{ uuid: string }>()
);

export const transmitApplicationSuccess = createAction(
  ActionTypes.TRANSMIT_APPLICATION_SUCCESS,
  props<{ data: any }>()
);

export const transmitApplicationFailed = createAction(
  ActionTypes.TRANSMIT_APPLICATION_FAILED,
  props<{ data: any }>()
);

export const changePassword = createAction(
  ActionTypes.CHANGE_PASSWORD,
  props<{ data: any }>()
);

export const changePasswordSuccess = createAction(
  ActionTypes.CHANGE_PASSWORD_SUCCESS,
  props<{ data: any }>()
);

export const changePasswordFailed = createAction(
  ActionTypes.CHANGE_PASSWORD_FAILED,
  props<{ data: any }>()
);
export const changePasswordModal = createAction(
  ActionTypes.CHANGE_PASSWORD_MODAL,
  props<{ data: any }>()
);

export const changePasswordModalSuccess = createAction(
  ActionTypes.CHANGE_PASSWORD_MODAL_SUCCESS,
  props<{ data: any }>()
);

export const changePasswordModalFailed = createAction(
  ActionTypes.CHANGE_PASSWORD_MODAL_FAILED,
  props<{ data: any }>()
);

export const getDashboardCounts = createAction(
  ActionTypes.GET_DASHBOARD_COUNTS,
  props<{ data: any }>()
);

export const getDashboardCountsSuccess = createAction(
  ActionTypes.GET_DASHBOARD_COUNTS_SUCCESS,
  props<{ data: any }>()
);

export const getDashboardCountsFailed = createAction(
  ActionTypes.GET_DASHBOARD_COUNTS_FAILED,
  props<{ data: any }>()
);

export const getFromPage = createAction(
  ActionTypes.FROM_PAGE,
  props<{ data: any }>()
);

// Roles & Permissions
export const getRolesPermission = createAction(
  ActionTypes.GET_ROLES_PERMISSIONS  
);

export const getRolesPermissionSuccess = createAction(
  ActionTypes.GET_ROLES_PERMISSIONS_SUCCESS,
  props<{ data: any }>()
);

export const getRolesPermissionFailed = createAction(
  ActionTypes.GET_ROLES_PERMISSIONS_FAILED,
  props<{ error: any }>()
);
